export default function Hero() {
  const scrollToCapabilities = () => {
    const element = document.getElementById('capabilities');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/3a84518c782a88ec6d6d597b9e7f3549.jpg)'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>

      <div className="absolute top-0 right-0 w-2/5 h-full opacity-20">
        <div className="absolute top-1/4 right-1/4 w-64 h-64 bg-[#1A2B4A]/30 rounded-lg transform rotate-12"></div>
        <div className="absolute top-1/3 right-1/3 w-48 h-48 bg-[#64748B]/20 rounded-lg transform -rotate-6"></div>
        <div className="absolute top-1/2 right-1/4 w-56 h-56 bg-white/10 rounded-lg transform rotate-3"></div>
      </div>

      <div className="relative z-10 w-full px-8 lg:px-16 max-w-7xl mx-auto">
        <div className="w-full lg:w-3/5">
          <h1 className="text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" style={{ fontFamily: 'Georgia, serif' }} spellCheck={false}>
            Strategic Digital Infrastructure & Asset Operations
          </h1>
          <p className="text-xl lg:text-2xl text-gray-200 font-light mb-12 max-w-2xl">
            Building, operating, and allocating capital across scalable digital platforms and real word assets.
          </p>
          <button
            onClick={scrollToCapabilities}
            className="px-8 py-4 bg-[#1A2B4A] text-white rounded-lg text-base font-medium hover:bg-[#0f1a2e] transition-all shadow-lg cursor-pointer whitespace-nowrap"
          >
            Our Capabilities
          </button>
        </div>
      </div>
    </section>
  );
}